export default __webpack_public_path__ + "static/media/cert-2.6acb7171.webp";